import { SincronizarTituloAba } from '@/app/SincronizarTituloAba';
import { AppProviders } from '@/app/providers';
import { AppRoutes } from '@/app/routes';
import { PushNavigateListener } from '@/features/push/PushNavigateListener';

export function App() {
  return (
    <AppProviders>
      <SincronizarTituloAba />
      <PushNavigateListener />
      <AppRoutes />
    </AppProviders>
  );
}
